export const DevOpsBannerContentArabic = {
  mainHeading: "خدمات وحلول",
  greenHeading: "ديف أوبس",
  subHeadingGreen:
    "موثوق بها من قبل الشركات الناشئة، والشركات الصغيرة والمتوسطة، والمؤسسات على حد سواء",
  sectionDescription:
    "قم بأتمتة سير العمل، وتسريع تسليم البرامج، وتقليل مخاطر النشر باستخدام خدمات ديف أوبس لدينا.",
  bannerButtonText: "استشر خبراء ديف أوبس لدينا",
};

export const devOpsServicesArabic = {
  servicesContent: {
    mainHeading: "خدمات ديف أوبس الشاملة من Bitsclan",
    sectionDescription:
      "في Bitsclan، نقدم خدمات ديف أوبس شاملة مصممة لتحسين دورة حياة تطوير البرامج الخاصة بك من البداية إلى النهاية. يدمج نهجنا التطوير والعمليات، مما يضمن تسليمًا أسرع وكفاءة أكبر وتحسينًا مستمرًا.",
  },
  servicesCards: [
    {
      title: "استشارات ديف أوبس",
      description:
        "تقدم خدمات استشارات ديف أوبس لدينا خارطة طريق واضحة وتخطيطًا تفصيليًا لتعزيز دورة حياة التطوير لديك، مما يضمن أن تحول ديف أوبس الخاص بك سلس ومتوافق مع أهداف عملك.",
    },
    {
      title: "خدمات سحابية",
      description:
        "استفد من تقنية السحابة من خلال خبرتنا في الخدمات السحابية لترحيل سحابي سلس وتحسين واستخدام الحاويات. نساعدك في إدارة قواعد البيانات، وتطبيق حلول قابلة للتطوير، وضمان أن البنية التحتية السحابية الخاصة بك فعالة وفعالة من حيث التكلفة.",
    },
    {
      title: "التكامل المستمر والتطوير المستمر",
      description:
        "يعني تطبيق CI/CD معنا رمزًا عالي الجودة ودورات تسليم أسرع. نحن نعزز شفافية العمل، ونسهل إصلاح الأخطاء بشكل أسرع، وندعم التطوير التكراري، مما يضمن أن برنامجك محدث دائمًا وجاهز للنشر.",
    },
    {
      title: "تطبيق أتمتة ديف أوبس",
      description:
        "قم بأتمتة عملياتك وتبسيط خط أنابيب التسليم الخاص بك من خلال خدمات أتمتة ديف أوبس لدينا. نتعامل مع كل شيء بدءًا من إدارة البنية التحتية وحتى التنسيق والنشر، مما يقلل من المهام اليدوية ويسرع دورة إصدار البرامج الخاصة بك.",
    },
    {
      title: "إدارة الخدمات المصغرة و Kubernetes واستخدام الحاويات",
      description:
        "اعتماد بنية الخدمات المصغرة من خلال إرشادات خبرائنا حول تقنيات استخدام الحاويات مثل Docker و Kubernetes. نضمن أن تطبيقاتك قابلة للتطوير ومرنة ومرنة، مما يمكّنك من إدارة عمليات النشر المعقدة بسهولة.",
    },
    {
      title: "ترحيل البيئة القديمة",
      description:
        "قم بتحديث أنظمتك القديمة من خلال خدمات تحديث الهندسة لدينا المدعومة من ديف أوبس. نضمن انتقالًا سلسًا إلى بيئات أحدث وأكثر كفاءة تتماشى مع احتياجات عملك الحالية والمستقبلية.",
    },
    {
      title: "DevSecOps",
      description:
        "تقدم خدمات DevSecOps الخاصة بنا عمليات تدقيق أمنية شاملة، وتطبق تدابير أمان سحابية، وتضمن حماية تطبيقاتك من التهديدات، كل ذلك مع الحفاظ على مرونة وسرعة عمليات ديف أوبس.",
    },
  ],
};

export const devOpsProcessStepsDataArabic = {
  processStepsContent: {
    mainHeading: "خدمات ديف أوبس لدينا تدفع ",
    greenText: "النمو التجاري الاستراتيجي",
    sectionDescription:
      "يمكن أن يؤدي تطبيق ديف أوبس إلى تغيير كبير في طريقة عمل عملك، مما يدفع الكفاءة والمرونة والابتكار. من خلال اعتماد أفضل ممارسات ديف أوبس والاستفادة من حلول ديف أوبس السحابية، فإنك تبسط عمليات التطوير والتشغيل لديك. تساعد الشراكة مع شركة خدمات ديف أوبس مثل Bitsclan IT Solutions على البقاء في صدارة المنافسة والتكيف مع المشهد الرقمي سريع التغير.",
  },

  processSteps: [
    {
      stepNumber: "01",
      title: "وقت أسرع للتسويق",
      content:
        "تسريع عمليات تطوير ونشر البرامج الخاصة بك، مما يضمن قدرتك على الاستجابة بسرعة لمتطلبات السوق.",
      icon: "/images/FAST.png",
      bgClass: "icon-change",
    },
    {
      stepNumber: "02",
      title: "تعاون محسّن",
      content:
        "عزز العمل الجماعي والتواصل الأفضل بين التطوير والعمليات، مما يقلل من الاختناقات ويحسن الكفاءة.",
      icon: "/images/FULL-ownership.png",
      bgClass: "",
    },
    {
      stepNumber: "03",
      title: "زيادة الكفاءة",
      content:
        "أتمتة المهام المتكررة لتقليل الأخطاء اليدوية وزيادة الإنتاجية عبر فرقك.",
      icon: "/images/FLEXIBILITY.png",
      bgClass: "",
    },
    {
      stepNumber: "04",
      title: "قابلية التوسع",
      content:
        "يمكنك بسهولة توسيع نطاق تطبيقاتك وبنيتك التحتية للتعامل مع زيادة حركة المرور ونمو الأعمال دون انقطاع.",
      icon: "/images/scalability.png",
      bgClass: "icon-change",
    },
    {
      stepNumber: "05",
      title: "أمان محسّن",
      content:
        "دمج الأمان من البداية مع المراقبة المستمرة وفحوصات الامتثال الآلية طوال دورة حياة التطوير.",
      icon: "/images/SECURE.png",
      bgClass: "",
    },
    {
      stepNumber: "06",
      title: "القدرة على التكيف",
      content:
        "ابق رشيقًا ومتجاوبًا مع تغيرات السوق بفضل المرونة التي توفرها إدارة الخدمات المصغرة وتقنيات الحاويات مثل Kubernetes و Docker.",
      icon: "/images/req-icon3.svg",
      bgClass: "",
    },
  ],
};

export const devOpsPageHireUsDataArabic = {
  hireUsDataContent: {
    mainHeading: "نتولى التحديات ونحل المشكلات",
    sectionDescription:
      "تعمل خدمات ديف أوبس لدينا على تحسين دورة حياة تطوير البرامج الخاصة بك باستخدام أحدث التقنيات. نقدم استراتيجيات مخصصة للتكامل المستمر والنشر والأتمتة لتعزيز التعاون والكفاءة.",
    buttonText: "استشر خبراء ديف أوبس لدينا",
  },

  hireUsDataCard: [
    {
      id: 1,
      icon: "/images/icon1.png",
      heading: "دمج ديف أوبس مع البنية التحتية الحالية لتكنولوجيا المعلومات",
      chalange:
        "دمج ممارسات ديف أوبس في البنية التحتية الحالية لتكنولوجيا المعلومات، والتي غالبًا ما تكون قديمة.",
      solution:
        "نجري تحليلًا شاملاً لبيئة تكنولوجيا المعلومات الحالية لديك وننشئ استراتيجية تحديث مخصصة. نضمن التكامل السلس لممارسات ديف أوبس مع أنظمتك الحالية، مما يقلل من الاضطرابات ويزيد الكفاءة.",
      borderClass: "border-1",
    },
    {
      id: 2,
      icon: "/images/icon2.png",
      heading: "إدارة الأمن والامتثال",
      chalange:
        "قد يكون الموازنة بين سرعة ديف أوبس والحاجة إلى إجراءات أمنية صارمة والامتثال للوائح الصناعية أمرًا صعبًا.",
      solution:
        "نقوم بدمج بروتوكولات الأمان في كل مرحلة من مراحل خط أنابيب ديف أوبس. تضمن ممارسات DevSecOps لدينا الحفاظ على الأمن والامتثال دون إبطاء عمليات التطوير لديك.",
      borderClass: "border-2",
    },
    {
      id: 3,
      icon: "/images/icon3.png",
      heading: "تعقيد التسليم والنشر المستمر",
      chalange:
        "يمكن أن يكون تنفيذ التكامل المستمر والنشر المستمر (CI/CD) معقدًا، خاصة في البيئات التي تتطلب تحديثات متكررة وفرقًا متعددة.",
      solution:
        "نقوم بتبسيط CI/CD عن طريق أتمتة عمليات التكامل والنشر. نستخدم أدوات ديف أوبس المتقدمة لضمان اختبار الكود ودمجه ونشره بكفاءة، مما يقلل من مخاطر الأخطاء ويسرع دورات الإصدار.",
      borderClass: "border-3",
    },
    {
      id: 4,
      icon: "/images/icon4.png",
      heading: "قلة التعاون بين الفرق",
      chalange:
        " يمكن أن يؤدي ضعف التعاون بين فرق التطوير والعمليات والأمن إلى اختناقات وعدم توافق الأهداف.",
      solution:
        "يعزز Bitsclan ثقافة التعاون من خلال قنوات اتصال منظمة وأدوات مشتركة. تم تصميم حلول ديف أوبس الخاصة بنا لكسر الحواجز، مما يضمن عمل جميع الفرق معًا بسلاسة نحو أهداف مشتركة.",
      borderClass: "border-1",
    },
    {
      id: 5,
      icon: "/images/icon5.png",
      heading: "توسيع نطاق ممارسات ديف أوبس",
      chalange:
        "مع نمو الأعمال، يصبح توسيع نطاق ممارسات ديف أوبس عبر فرق وتطبيقات متعددة أمرًا صعبًا بشكل متزايد.",
      solution:
        "نحن نطبق بنية الخدمات المصغرة، واستخدام الحاويات، والمنصات السحابية لضمان إمكانية توسيع نطاق ممارسات ديف أوبس الخاصة بك بسهولة، ودعم عملياتك المتوسعة دون المساومة على الأداء.",
      borderClass: "border-2",
    },
  ],
  challenge: "تحدي",
  solution: "حل",
};

export const devOpsSolutionsDataArabic = {
  solutionDataContent: {
    mainHeading: "لماذا تختار Bitsclan لحلول ديف أوبس الخاصة بك",
    sectionDescription:
      "يعد اختيار الشريك المناسب لاحتياجات ديف أوبس الخاصة بك أمرًا بالغ الأهمية لضمان نجاح عمليات التطوير والتشغيل الخاصة بك. في Bitsclan، نقدم خبرة لا مثيل لها والتزامًا بالتميز في كل مشروع نقوم به.",
  },
  solutionsDataCards: [
    {
      title: "فريق خبراء",
      description:
        "نقدم حلولًا مبتكرة ومتقدمة تقنيًا لتبسيط عملياتك وتحقيق الكفاءة.",
    },
    {
      title: "خدمة شاملة",
      description:
        "من الاستشارة والتخطيط الأوليين إلى التنفيذ والدعم المستمر، ندير دورة حياة ديف أوبس بأكملها.",
    },
    {
      title: "تسليم عالي الجودة",
      description:
        "نولي الأولوية للجودة في كل مرحلة، مع اختبار صارم ومراقبة والتحقق لضمان نتائج موثوقة وآمنة.",
      noBorder: true,
    },
    {
      title: "قابلية التوسع والمرونة",
      description:
        "نضمن أن بنيتك التحتية يمكن أن تنمو مع عملك، مما يوفر المرونة اللازمة للبقاء قادرًا على المنافسة.",
    },
    {
      title: "نهج الأمن أولاً",
      description:
        "تتضمن خدمات ديف أوبس لدينا ممارسات أمنية من الألف إلى الياء، مما يضمن حماية تطبيقاتك وبياناتك.",
    },
    {
      title: "محاذاة المنطقة الزمنية",
      description:
        "نحن نضمن التعاون السلس من خلال التوافق مع منطقتك الزمنية، مما يسمح بالتواصل في الوقت الفعلي واتخاذ القرارات السريع.",
    },
  ],
};

export const devOpsRoadMapContentArabic = {
  mainHeading: "خط أنابيب ديف أوبس منظم لـ",
  greenHeading: "دفع نجاحك",
  sectionDescription:
    "في بيتسكلان، نتبع نهجًا منهجيًا لتبسيط عمليات تكنولوجيا المعلومات الخاصة بك مع تقديم قيمة مستمرة وأداء موثوق، مما يضمن ازدهار عملك في مشهد تكنولوجي دائم التطور.",
  roadMapHeading1: "التحليل والتخطيط",
  roadMapDescription1:
    " نبدأ بإجراء تحليل شامل للبنية التحتية الحالية لتكنولوجيا المعلومات لديك. يتيح لنا ذلك تحديد مجالات التحسين وإنشاء خطة تحديث استراتيجية.",
  roadMapHeading2: "تطوير الحل الخاص بك",
  roadMapDescription2:
    "في مرحلة التطوير، تقوم فرق الخبراء لدينا ببناء وتخصيص الحل الخاص بك باستخدام أحدث تقنيات ديف أوبس لضمان كود عالي الجودة ودورات تسليم أسرع.",
  roadMapHeading3: "تطبيق بروتوكولات الأمان",
  roadMapDescription3:
    "نحن نطبق بروتوكولات أمان رائدة في الصناعة لحماية تطبيقاتك وبنيتك التحتية وبياناتك، مما يضمن الامتثال للمعايير التنظيمية والحماية من التهديدات.",
  roadMapHeading4: "التكامل المستمر والنشر المستمر",
  roadMapDescription4:
    "تضمن ممارسات CI/CD لدينا دمج التحديثات والميزات الجديدة ونشرها بكفاءة، مما يتيح إصدارات أسرع ويقلل من وقت التوقف عن العمل.",
  roadMapHeading5: "الدعم والصيانة",
  roadMapDescription5:
    "نقدم دعمًا وصيانة مستمرين للحفاظ على أنظمتك محسّنة وآمنة وتعمل بسلاسة، مما يضمن الأداء المستمر والتوافر.",
};

export const devOpsCoverTheStackArabic = {
  converTheStackContent: {
    mainHeading:
      "حسّن مسار ديف أوبس الخاص بك باستخدام حزمة التكنولوجيا الرائدة في الصناعة",
    sectionDescription:
      "في Bitsclan، نضمن أن عمليات ديف أوبس الخاصة بك مدعومة بأكثر التقنيات المتقدمة المتاحة. تم تصميم حزمتنا التقنية المنسقة بعناية لزيادة الكفاءة والأمان وقابلية التوسع في كل مرحلة من مراحل دورة حياة تطوير البرامج. من خلال الاستفادة من هذه الأدوات المتطورة، نساعدك على تحقيق عمليات نشر أسرع وأداء أفضل ونتائج عالية الجودة، مع الحفاظ على معايير صارمة للأمان والامتثال.",
    defaultOpenTab: "ديف أوبس",
  },

  tabs: [
    "قاعدة البيانات",
    "الواجهة الخلفية",
    "الهاتف المحمول",
    "الواجهة الأمامية",
    "الأطر",
    "السحابة",
    "ديف أوبس",
    "التجارة الإلكترونية",
    "المنصات",
  ],

  tabItems: [
    {
      tab: "الواجهة الأمامية",
      icon: "/images/iconone.png",
      name: "Angular JS",
    },
    {
      tab: "الواجهة الأمامية",
      icon: "/images/icontwo.png",
      name: "JavaScript",
    },
    {
      tab: "الواجهة الأمامية",
      icon: "/images/iconthree.png",
      name: "React JS",
    },
    { tab: "الواجهة الأمامية", icon: "/images/icon4.png", name: "Vue JS" },
    { tab: "الواجهة الأمامية", icon: "/images/icon5.png", name: "Tez JS" },
    { tab: "الواجهة الأمامية", icon: "/images/icon6.png", name: "CSS3" },
    { tab: "الواجهة الأمامية", icon: "/images/icon7.png", name: "HTML5" },
    { tab: "الواجهة الخلفية", icon: "/images/database1.png", name: ".Net" },
    { tab: "الواجهة الخلفية", icon: "/images/database2.png", name: "Nest Js" },
    {
      tab: "الواجهة الخلفية",
      icon: "/images/database3.png",
      name: "Meteor JS",
    },
    { tab: "الواجهة الخلفية", icon: "/images/database4.png", name: "Fastify" },
    {
      tab: "الواجهة الخلفية",
      icon: "/images/database5.png",
      name: "Express JS",
    },
    { tab: "الواجهة الخلفية", icon: "/images/database6.png", name: "Python" },
    { tab: "الواجهة الخلفية", icon: "/images/database7.png", name: "Java" },
    { tab: "الواجهة الخلفية", icon: "/images/database8.png", name: "PHP" },
    { tab: "الواجهة الخلفية", icon: "/images/database9.png", name: "Node Js" },
    { tab: "الهاتف المحمول", icon: "/images/mobile1.png", name: "Android" },
    { tab: "الهاتف المحمول", icon: "/images/mobile2.png", name: "IOS" },
    { tab: "الهاتف المحمول", icon: "/images/mobile3.png", name: "Swift" },
    { tab: "الهاتف المحمول", icon: "/images/mobile4.png", name: "Flutter" },
    { tab: "الهاتف المحمول", icon: "/images/mobile5.png", name: "Xamarin" },
    {
      tab: "الهاتف المحمول",
      icon: "/images/mobile6.png",
      name: "React Native",
    },
    { tab: "قاعدة البيانات", icon: "/images/db1.png", name: "Firebase" },
    { tab: "قاعدة البيانات", icon: "/images/db2.png", name: "Oracle " },
    { tab: "قاعدة البيانات", icon: "/images/db3.png", name: "MongoDB" },
    {
      tab: "قاعدة البيانات",
      icon: "/images/tech-stack-icons/postgres.svg",
      name: "PostgreSQL",
    },
    { tab: "قاعدة البيانات", icon: "/images/db5.png", name: "MySQL" },
    { tab: "قاعدة البيانات", icon: "/images/db6.png", name: "SQL Server" },
    { tab: "قاعدة البيانات", icon: "/images/db7.png", name: "SQLite" },
    { tab: "قاعدة البيانات", icon: "/images/db8.png", name: "DynamoDB" },
    { tab: "الأطر", icon: "/images/framework1.png", name: "MEAN" },
    { tab: "الأطر", icon: "/images/framework2.png", name: "CodeIgniter" },
    { tab: "الأطر", icon: "/images/framework3.png", name: "Laravel" },
    { tab: "الأطر", icon: "/images/framework4.png", name: "Rxweb.io" },
    { tab: "الأطر", icon: "/images/framework5.png", name: "CakePHP" },
    { tab: "الأطر", icon: "/images/framework6.png", name: "Django" },
    { tab: "السحابة", icon: "/images/cloud1.png", name: "Google Cloud" },
    { tab: "السحابة", icon: "/images/cloud2.png", name: "Azure" },
    { tab: "السحابة", icon: "/images/cloud3.png", name: "AWS" },
    { tab: "ديف أوبس", icon: "/images/devops1.png", name: "Gradle" },
    { tab: "ديف أوبس", icon: "/images/devops2.png", name: "Kubernetes" },
    { tab: "ديف أوبس", icon: "/images/devops3.png", name: "Docker" },
    { tab: "ديف أوبس", icon: "/images/devops4.png", name: "Jenkins" },
    {
      tab: "التجارة الإلكترونية",
      icon: "/images/ecomres1.png",
      name: "NopCommerce",
    },
    {
      tab: "التجارة الإلكترونية",
      icon: "/images/ecomres2.png",
      name: "Kentico",
    },
    {
      tab: "التجارة الإلكترونية",
      icon: "/images/ecomres3.png",
      name: "Shopify",
    },
    {
      tab: "التجارة الإلكترونية",
      icon: "/images/ecomres4.png",
      name: "Magento",
    },
    {
      tab: "التجارة الإلكترونية",
      icon: "/images/ecomres5.png",
      name: "WooCommerce",
    },
    { tab: "المنصات", icon: "/images/platform1.png", name: "Servicenow " },
    { tab: "المنصات", icon: "/images/platform2.png", name: "Tableau" },
    {
      tab: "المنصات",
      icon: "/images/platform3.png",
      name: "MS Dynamics CRM",
    },
    { tab: "المنصات", icon: "/images/platform4.png", name: "Zoho" },
    { tab: "المنصات", icon: "/images/platform5.png", name: "Power BI" },
    { tab: "المنصات", icon: "/images/platform6.png", name: "Salesforce " },
  ],
};

export const WhyChoseUsDataArabic = {
  whyChoseBitsclanContent: {
    mainHeading: "حلول ديف أوبس قابلة للتطوير وآمنة لتطبيقات الويب",
    sectionDescription:
      "بصفتنا وكالة رائدة في تطوير تطبيقات الويب، نحن متخصصون في تقديم مجموعة متنوعة من تطبيقات الويب المصممة خصيصًا لتلبية الاحتياجات الفريدة لعملائنا. تمتد خبرتنا عبر صناعات متعددة ومتطلبات وظيفية، مما يضمن قدرتنا على تطوير حلول مبتكرة تدفع الكفاءة والمشاركة والنمو. فيما يلي بعض الأنواع الرئيسية لتطبيقات الويب التي نقدمها.",
    sectionButtonText: "احجز مكانًا الآن",
  },
  whyChoseBitsclanTabs: [
    {
      id: "Tab1",
      label: "تطبيقات الويب للمؤسسات",
      content:
        "عزز عمليات المؤسسة بأتمتة تعتمد على DevOps، وتكاملات سلسة، وسير عمل محسّن لزيادة المرونة والكفاءة.",
      featureList: [
        { text: "إدارة البنية التحتية القابلة للتطوير" },
        { text: "النشر والمراقبة المستمرة" },
        { text: "الأمان والامتثال الآلي" },
        { text: "حلول المؤسسات السحابية الأصلية" },
        { text: "تحسين الأداء" },
      ],
    },
    {
      id: "Tab2",
      label: "تطبيقات الويب لإدارة سلسلة التوريد",
      content:
        "حسن كفاءة اللوجستيات وسلسلة التوريد من خلال الأتمتة التي تدعمها DevOps، والتحليلات التنبؤية، والحلول السحابية السلسة.",
      featureList: [
        { text: "تتبع المخزون في الوقت الفعلي" },
        { text: "خطوط أنابيب النشر الآلي" },
        { text: "واجهات برمجة التطبيقات الآمنة والقابلة للتطوير" },
        { text: "مراقبة الأداء والتنبيهات" },
        { text: "تحسين اللوجستيات المستند إلى السحابة" },
      ],
    },
    {
      id: "Tab3",
      label: "بوابات الويب",
      content:
        "مكّن تفاعلات المستخدم السلسة مع بوابات الويب المدعومة من ديف أوبس التي تتميز بتوافر عالٍ وأمان ومراقبة الأداء في الوقت الفعلي.",
      featureList: [
        { text: "التحجيم التلقائي وموازنة التحميل" },
        { text: "CI/CD لتحديثات أسرع" },
        { text: "إدارة بوابة API الآمنة" },
        { text: "الأداء المحسّن للسحابة" },
        { text: "تحليلات ورؤى مدعومة بالذكاء الاصطناعي" },
      ],
    },
    {
      id: "Tab4",
      label: "تطبيقات موجهة للعملاء",
      content:
        "قدم تطبيقات موثوقة وعالية الأداء باستخدام استراتيجيات تعتمد على DevOps، مما يضمن عمليات نشر سلسة وأمان وتجارب مستخدم محسّنة.",
      featureList: [
        { text: "عمليات نشر بدون توقف" },
        { text: "اختبار الأداء الآلي" },
        { text: "إدارة الوصول والهوية الآمنة" },
        { text: "مراقبة الأخطاء في الوقت الفعلي" },
        { text: "تكامل الحوسبة السحابية والحوسبة الطرفية" },
      ],
    },
    {
      id: "Tab5",
      label: "خدمات الويب عبر الإنترنت",
      content:
        "حسّن الخدمات عبر الإنترنت باستخدام منهجيات DevOps، مما يعزز قابلية التوسع والأتمتة والأمان للحصول على تجارب رقمية سلسة.",
      featureList: [
        { text: "استراتيجية التطوير القائمة على واجهة برمجة التطبيقات أولاً" },
        { text: "المراقبة المستمرة والاستجابة للحوادث" },
        { text: "DevSecOps لتطبيقات آمنة" },
        { text: "استضافة وإدارة سحابية قابلة للتطوير" },
        { text: "أنظمة ذاتية الشفاء ومتسامحة مع الأخطاء" },
      ],
    },
    {
      id: "Tab6",
      label: "تطبيقات ويب تحليلية",
      content:
        "احصل على رؤى قابلة للتنفيذ باستخدام منصات التحليلات التي تعتمد على ديف أوبس والتي تضمن معالجة البيانات في الوقت الفعلي والنمذجة التنبؤية وعمليات التكامل السحابية الآمنة.",
      featureList: [
        { text: "خطوط أنابيب معالجة البيانات في الوقت الفعلي" },
        { text: "إدخال البيانات الآلي و ETL" },
        { text: "تحليلات قائمة على السحابة قابلة للتطوير" },
        { text: "نشر نماذج الذكاء الاصطناعي والتعلم الآلي" },
        { text: "إدارة البيانات الآمنة والمتوافقة" },
      ],
    },
  ],
};

export const DevOpsFaqDataArabic = {
  faqDataContent: {
    mainHeading: "الأسئلة المتكررة",
  },
  questionAndAnswer: [
    {
      id: "collapseOne",
      question: "ما هي خدمات ديف أوبس بعبارات بسيطة؟",
      answer:
        "تجمع خدمات ديف أوبس بين ممارسات التطوير والعمليات لأتمتة وتبسيط دورة حياة تطوير البرامج، مما يضمن تسليمًا أسرع وأكثر موثوقية للبرامج.",
    },
    {
      id: "collapseTwo",
      question: "ما هي أمثلة ديف أوبس كخدمة؟",
      answer:
        "تشمل الأمثلة التكامل المستمر والنشر المستمر (CI/CD)، وأتمتة البنية التحتية، وإدارة السحابة، والمراقبة والتسجيل كخدمات تعزز الكفاءة والتعاون.",
    },
    {
      id: "collapseThree",
      question: "ما هي CI و CD في DevOps؟",
      answer:
        "CI (التكامل المستمر) هي ممارسة دمج تغييرات الكود بانتظام، بينما CD (النشر المستمر) هو الإصدار الآلي لهذه التغييرات لبيئات الإنتاج.",
    },
    {
      id: "fourth",
      question: "ما هي خدمة ديف أوبس المدارة؟",
      answer:
        "تتضمن خدمة ديف أوبس المدارة الاستعانة بمصادر خارجية لإدارة عمليات DevOps، بما في ذلك البنية التحتية والأتمتة والتسليم المستمر، لمزود متخصص مثل Bitsclan.",
    },
    {
      id: "fifth",
      question: "ما هي نماذج التفاعل في Bitsclan في خدمات ديف أوبس؟",
      answer:
        "تقدم Bitsclan نماذج تفاعل مرنة بما في ذلك الخدمات القائمة على المشاريع، والفرق المخصصة، والخدمات المدارة، المصممة لتلبية الاحتياجات والأهداف المحددة لمؤسستك.",
    },
    {
      id: "sixth",
      question: "كيف تقارن Bitsclan بمقدمي خدمات ديف أوبس الآخرين؟",
      answer:
        "تتميز Bitsclan بحلول ديف أوبس المخصصة والشاملة، وفريق الخبراء، والالتزام بالجودة، مما يضمن تسليم مشاريعك في الوقت المحدد ومتوافقة مع أهداف عملك.",
    },
    {
      id: "seventh",
      question: "ما الفرق بين Agile و DevOps؟",
      answer:
        "يركز Agile على التطوير التكراري والتعاون داخل الفرق، بينما يوسع ديف أوبس هذا التعاون ليشمل العمليات، مع التركيز على الأتمتة والتسليم المستمر.",
    },
  ],
};

export const PionerChangeHeadingsArabic = {
  mainHeading: "ريادة التغيير",
  greenHeading: "عبر الصناعات",
  sectionDescription:
    "تمتد خبرتنا في تطوير تطبيقات الهاتف المحمول عبر مجموعة واسعة من الصناعات، حيث نقدم حلولًا مخصصة تلبي المتطلبات الفريدة لكل قطاع.",
};
